module.exports = __webpack_public_path__ + "static/media/lds-logo_uk.80cdd745.svg";